// extracted by mini-css-extract-plugin
export default {"codeModalContainer":"styles_codeModalContainer__QCZkw","resendCode":"styles_resendCode__Y9Eao"};